import { Link as RouterLink } from 'react-router-dom';

import styled from 'styled-components';
import { ColorPalette } from 'theme/colors';

export const Item = styled.li`
  &:not(:last-child) {
    border-bottom: 1px solid ${ColorPalette.HEX.BrightGray};
  }

  &:first-child {
    border-top-left-radius: ${({ theme }) => theme.menuList.borderRadius};
    border-top-right-radius: ${({ theme }) => theme.menuList.borderRadius};
  }

  &:last-child {
    border-bottom-left-radius: ${({ theme }) => theme.menuList.borderRadius};
    border-bottom-right-radius: ${({ theme }) => theme.menuList.borderRadius};
  }
`;

export const Link = styled(RouterLink)`
  display: flex;
  padding: 24px 16px;
  align-items: center;
  text-decoration: none;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.43;
  color: ${ColorPalette.HEX.CharlestonGreen};
`;

export const Button = styled.button`
  width: 100%;
  text-align: left;
  display: flex;
  padding: 24px 16px;
  align-items: center;
  text-decoration: none;
  font-size: 14px;
  font-weight: 600;
  line-height: 1.43;
  color: ${ColorPalette.HEX.CharlestonGreen};
  background-color: ${ColorPalette.Transparent};
`;

export const Label = styled.span`
  flex: 1;
  margin-right: 16px;
`;

export const Icon = styled.img`
  height: 8px;
`;
